// src/lib/admin.js
// 관리자 전용 프록시(/admin-api)를 호출한다. nginx가 X-Admin-Secret 헤더를 자동 추가함.
const ADMIN_BASE = '/api';

async function httpA(path, options = {}) {
  const res = await fetch(`${ADMIN_BASE}${path}`, {
    credentials: 'include',
    ...(options || {}),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status} ${res.statusText} ${text}`);
  }
  const ct = res.headers.get('content-type') || '';
  return ct.includes('application/json') ? res.json() : null;
}

// 공지 목록
export async function adminListNotices({ size = 100 } = {}) {
  const data = await httpA(`/notices?size=${size}`);
  return Array.isArray(data) ? data : (data?.content || []);
}

// 공지 등록
export async function adminCreateNotice({ type, title, content, hasFile }) {
  return httpA('/notices', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type, title, content, hasFile: !!hasFile }),
  });
}
// 공지 수정
export async function adminUpdateNotice(id, { type, title, content, hasFile }) {
  return httpA(`/notices/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type, title, content, hasFile: !!hasFile }),
  });
}
// 공지 삭제
export async function adminDeleteNotice(id) {
  return httpA(`/notices/${id}`, { method: 'DELETE' });
}

// 파일 업로드
export async function adminUploadNoticeFile(noticeId, file) {
  const fd = new FormData();
  fd.append('file', file);
  return httpA(`/notices/${noticeId}/files`, {
    method: 'POST',
    body: fd,
  });
}
